import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import IconButton from '@material-ui/core/IconButton';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableFooter from '@material-ui/core/TableFooter';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import RefreshIcon from '@material-ui/icons/Autorenew';
import NewFromTemplateIcon from '@material-ui/icons/FileCopyOutlined';
import DeleteIcon from '@material-ui/icons/RemoveCircleOutline';
import { Entity } from '@sketchpixy/rubix/lib/L20n';
import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import { BLUE, CUSTOM_SNIPPET_ENTITY_TYPES_PARAMETERS, CUSTOM_SNIPPET_EVENT_TYPES_PARAMETERS, TABLE_HEADER_COLOR } from '../../_config/consts';
import { getColorFromThemeName } from '../../_config/utils';
import EmptyView from '../EmptyView.jsx';
import ListLoadingView from '../ListLoadingView.jsx';
import MDTablePaginationActions from '../MDTable/MDTablePaginationActions.jsx';
import CodeIcon from '@material-ui/icons/Code';

const styles = theme => ({
  table: {
    overflow: 'scroll',
  },
  tableColumnText: {
    fontWeight: 'bold',
    color: '#3f3f3f',
  },
  disabledInput: {
    display: 'none',
  },
  rowSelected: {
    backgroundColor: 'aliceblue !important',
    color: 'aliceblue !important',
  },
  rowHovered: {
    cursor: 'pointer',
  },
  row: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.background.default,
    },
    minHeight: 80,
  },
  actionContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  rowWithAction: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  rowActionButton: {
    width: 40,
    height: 40,
  },
  rowActionButtonIcon: {
    fontSize: 20,
    color: '#E53935',
  },
  paginationText: {
    fontSize: 16,
    fontWeight: 'bold',
    color: 'white',
  },
  button: {
    color: 'red',
    fontSize: 13,
    fontWeight: 'bold',
    textDecoration: 'underline',
    marginLeft: -8,
    marginTop: 5,
    marginBottom: 5,
    width: 'max-content',
  },
  buttonPositive: {
    color: BLUE,
    fontSize: 13,
    fontWeight: 'bold',
    textDecoration: 'underline',
    marginLeft: -8,
    marginTop: 5,
    marginBottom: 5,
    width: 'max-content',
  },
});

@connect((state) => ({ 
  viewLoading: state.utils.viewLoading, 
  customSnippets: state.customTables.snippets, 
  themeName: state.settings.items.theme.data.themeName 
}))
class CustomSnippetTableView extends React.Component {
  render() {
    const {
      classes,
      viewLoading,
      themeName,
      canCreateItem,
      onDeleteCustomSnippet,
      onCreateCustomSnippetFromModel,
      onNewCustomSnippet,
      customSnippets: { selectedCustomSnippet, content: customSnippetsData, pagination: { number: currentPage, size, totalPages, totalElements }},
      onSelectCustomSnippet,
      onRefreshCustomSnippets,
      onFetchCustomSnippetsOnPage,
    } = this.props;
    const headerColor = getColorFromThemeName(themeName);
    return (
      <div className="list-view details-section" style={{ top: 150, paddingBottom: 140, width: '87%' }}>
        <div>
          {!_.isEmpty(customSnippetsData) ?
            <Card style={{ overflow: 'scroll' }}>
              <Table size="small" className={classes.table}>
                <TableHead>
                  <TableRow style={{ backgroundColor: TABLE_HEADER_COLOR }}>
                    <TableCell colSpan={3}>
                      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                        <h3 className={classes.tableColumnText} style={{ color: 'white', marginTop: 15, marginBottom: 15 }}>
                          <Entity entity="customSnippets" />
                        </h3>
                        <IconButton onClick={() => onRefreshCustomSnippets()} style={{ marginLeft: 10, marginTop: 5 }}>
                          <RefreshIcon style={{ color: 'white', fontSize: 25 }} />
                        </IconButton>
                      </div>
                    </TableCell>
                    <TablePagination
                      colSpan={0}
                      count={!_.isUndefined(totalElements) ? totalElements : 0}
                      rowsPerPage={!_.isUndefined(size) ? size : 0}
                      page={!_.isUndefined(currentPage) ? currentPage : 0}
                      labelRowsPerPage=" "
                      classes={{
                        input: classes.disabledInput,
                      }}
                      labelDisplayedRows={({ from, to, count }) => (
                        <h4 className={classes.paginationText}>
                          <Entity
                            key={`${from}-${totalPages}-${count}`}
                            entity="customSnippetsTablePagination"
                            data={{
                              currentPage: !_.isUndefined(currentPage) ? currentPage + 1 : 0,
                              totalPages: !_.isUndefined(totalPages) ? totalPages : 0,
                              count: !_.isUndefined(count) ? count : 0,
                            }}
                          />
                        </h4>
                      )}
                      onChangePage={(event, page) => onFetchCustomSnippetsOnPage(page)}
                      ActionsComponent={() => (
                        <MDTablePaginationActions
                          count={totalElements}
                          iconColor="white"
                          page={currentPage}
                          lastPage={totalPages - 1}
                          rowsPerPage={size}
                          onChangePage={(event, page) => onFetchCustomSnippetsOnPage(page)}
                        />
                      )}
                    />
                  </TableRow>
                  <TableRow style={{ backgroundColor: 'white' }}>
                    <TableCell><h4 className={classes.tableColumnText}><Entity entity="snippetName" /></h4></TableCell>
                    <TableCell><h4 className={classes.tableColumnText}><Entity entity="entity" /></h4></TableCell>
                    <TableCell><h4 className={classes.tableColumnText}><Entity entity="event" /></h4></TableCell>
                    <TableCell><h4 className={classes.tableColumnText}><Entity entity="actions" /></h4></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {_.map(customSnippetsData, (snippet) => {
                    return (
                      <TableRow
                        key={snippet.id}
                        className={classes.row}
                        hover
                        classes={{
                          selected: classes.rowSelected,
                          hover: classes.rowHovered,
                        }}
                        onClick={event => onSelectCustomSnippet(snippet)}
                        selected={selectedCustomSnippet && selectedCustomSnippet.id === snippet.id}
                      >
                        <TableCell>
                          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                            <CodeIcon style={{ marginRight: 10, color: '#3f3f3f' }} />
                            <h5 style={{ fontWeight: 'bold', lineHeight: '1.5', fontSize: 16 }}>{snippet.name}</h5>
                          </div>
                        </TableCell>
                        <TableCell style={{ maxWidth: 750 }}>
                          <div style={{ display: 'flex', alignItems: 'center', wordBreak: 'break-all' }}>
                            <h5 style={{ lineHeight: '1.5', fontSize: 14 }}>{<Entity entity={CUSTOM_SNIPPET_ENTITY_TYPES_PARAMETERS[snippet.entity].string} />}</h5>
                          </div>
                        </TableCell>
                        <TableCell style={{ maxWidth: 750 }}>
                          <div style={{ display: 'flex', alignItems: 'center', wordBreak: 'break-all' }}>
                            <h5 style={{ lineHeight: '1.5', fontSize: 14 }}>{<Entity entity={CUSTOM_SNIPPET_EVENT_TYPES_PARAMETERS[snippet.event].string} />}</h5>
                          </div>
                        </TableCell>
                        <TableCell>
                          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'start' }}>
                            <Button
                              onClick={(event) => {
                                event.stopPropagation();
                                onDeleteCustomSnippet(snippet.id);
                              }}
                              className={classes.button}
                            >
                              <Entity entity="delete" />
                              <DeleteIcon style={{ fontSize: 15, marginLeft: 5 }} />
                            </Button>
                          </div>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
                <TableFooter>
                  <TableRow style={{ backgroundColor: TABLE_HEADER_COLOR }}>
                    <TablePagination
                      colSpan={0}
                      count={!_.isUndefined(totalElements) ? totalElements : 0}
                      rowsPerPage={!_.isUndefined(size) ? size : 0}
                      page={!_.isUndefined(currentPage) ? currentPage : 0}
                      labelRowsPerPage=" "
                      classes={{
                        input: classes.disabledInput,
                      }}
                      labelDisplayedRows={({ from, to, count }) => (
                        <h4 className={classes.paginationText}>
                          <Entity
                            key={`${from}-${totalPages}-${count}`}
                            entity="customSnippetsTablePagination"
                            data={{
                              currentPage: !_.isUndefined(currentPage) ? currentPage + 1 : 0,
                              totalPages: !_.isUndefined(totalPages) ? totalPages : 0,
                              count: !_.isUndefined(count) ? count : 0,
                            }}
                          />
                        </h4>
                      )}
                      onChangePage={(event, page) => onFetchCustomSnippetsOnPage(page)}
                      ActionsComponent={() => (
                        <MDTablePaginationActions
                          count={totalElements}
                          page={currentPage}
                          iconColor="white"
                          lastPage={totalPages - 1}
                          rowsPerPage={size}
                          onChangePage={(event, page) => onFetchCustomSnippetsOnPage(page)}
                        />
                      )}
                    />
                  </TableRow>
                </TableFooter>
              </Table>
            </Card>
            : (
              <div>
                {!viewLoading ? (
                  <EmptyView
                    title="noCustomSnippets"
                    onNewEntity={canCreateItem ? () => onNewCustomSnippet() : null}
                    newEntityTitle="addCustomSnippet"
                    subtitle="startCustomSnippets"
                    iconName="icon-simple-line-icons-code"
                  />) : <ListLoadingView />}
              </div>
            )}
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(CustomSnippetTableView); 